import {Component, inject, Inject, OnInit, TemplateRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {JsonPipe, NgTemplateOutlet} from '@angular/common';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
  MatOption
} from '@angular/material/autocomplete';
import {MatSelect} from '@angular/material/select';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {IsEnabledDirective} from '../../../../core/directives/is-enabled.directive';
import {
  AccessDeniedMessageComponent
} from '../../../../shared/components/access-denied-message/access-denied-message.component';
import {IndexItemsListComponent} from '../../index-entity/index-items-list/index-items-list.component';
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {UnitSelectorComponent} from '../../index-entity/unit-selector/unit-selector.component';
import {DepartmentService, OrganizationService, ReferenceService,} from '../../../apiModule1';
import {MultiSelect3Component} from '../../../../shared/components/multi-select3/multi-select3.component';
import {FillingMethodComponent} from '../../index-entity/filling-method/filling-method.component';
import {ChoiseComponent} from '../../../../shared/components/choise/choise.component';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {map} from 'rxjs/operators';
import {CommunicationService} from '../../../../core/services/communication.service';


@Component({
    selector: 'pas-dialog-grade',
    standalone: true,
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
    imports: [
        MatFormField,
        MatDialogClose,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        JsonPipe,
        MatAutocomplete,
        MatOption,
        ReactiveFormsModule,
        MatAutocompleteTrigger,
        MatSelect,
        AccessDeniedMessageComponent,
        IsEnabledDirective,
        MatIcon,
        MatIconButton,
        IndexItemsListComponent,
        MatButton,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        NgTemplateOutlet,
        UnitSelectorComponent,
        MultiSelect3Component,
        FillingMethodComponent,
        ChoiseComponent,
        MultiSelect2Component,
    ],
})
export class DialogComponent implements OnInit {

    isNew: boolean = false;

    toastService = inject(CommunicationService);
    referenceService: ReferenceService = inject(ReferenceService);
    roles: Role[] = [];
    currentRole: Role | null = null;

    content: TemplateRef<any> | null = null;
    organizations: Organization[] = [];
    departments: Department[] = [];


    mainForm: FormGroup = new FormGroup({
        organization: new FormControl<Organization>(this.data['organization'] || {}),
        department: new FormControl<Organization>(this.data['department'] || {}),
        position: new FormControl<string>(''),
        fio: new FormControl<string>('',[Validators.required]),
        email: new FormControl<string>('', [Validators.required, Validators.email]),
        phone: new FormControl('', [Validators.required,Validators.pattern(/\d{10}/)]),
        login: new FormControl<string>('',[Validators.required]),
        password: new FormControl<string>('',[Validators.required]),
    })
    isEnabled: boolean = false;

    get formControls() {
        return this.mainForm.controls;
    }


    constructor(
        public dialogRef: MatDialogRef<DialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
        public organizationService: OrganizationService,
        public departmentService: DepartmentService,
    ) {
        this.isNew = data['isNew'];
        console.log('data', data);

        this.organizationService.apiOrganizationGet({}).pipe(map(v => v.values)).subscribe((v: Organization[]) => {
            this.organizations = v;
            const foundOrganization = this.organizations.find(v => v.id === this.data['organization']?.id);
            if (foundOrganization) {
                this.mainForm.get('organization')!.setValue(foundOrganization);
            }
        })

        this.departmentService.apiDepartmentGet({}).pipe(map(v => v.values)).subscribe((v: Department[]) => {
            this.departments = v;
            const foundDepartment = this.departments.find(v => v.id === this.data['departments']?.id);
            if (foundDepartment) {
                this.mainForm.get('organization')!.setValue(foundDepartment);
            }
        })

        this.referenceService.apiReferenceRolesGet()
            .pipe(map(v => v.values))
            .subscribe((v: Role[]) => {
                this.roles = v;
            });

        console.log('isNew', this.isNew, this.data);

        if (!this.isNew) {
            this.currentRole = this.data['roles'][0];
            this.data['position'] && this.mainForm.get('position')!.setValue(this.data['position']);
            this.data['email'] && this.mainForm.get('email')!.setValue(this.data['email']);
            this.data['phone'] && this.mainForm.get('phone')!.setValue(_phoneMask(this.data['phone'].slice(-10)));
            this.data['userName'] && this.mainForm.get('login')!.setValue(this.data['userName']);
            this.data['password'] && this.mainForm.get('password')!.setValue(this.data['password']);

            this.mainForm.get('fio')!.setValue(this.data['lastName'] + ' ' + this.data['firstName'] + ' ' + this.data['middleName']);

        }
    }


    onNoClick(): void {
        this.dialogRef.close();
    }

    onApply() {
        this.mainForm.markAllAsTouched();
        const [lastName, firstName, middleName] = this.mainForm.get('fio')?.value.split(' ')
            .map((v: string) => v.trim()).filter(Boolean);
        if(this.mainForm.invalid){
            return this.toastService.error('Проверьте правильность заполнения формы');
        }
        const res: User = {
            id: this.data['id'],
            email: this.mainForm.get('email')?.value,
            firstName,
            lastName,
            middleName,
            position: this.mainForm.get('position')?.value,
            phone: this.mainForm.get('phone')?.value,
            userName: this.mainForm.get('login')?.value,
            password: this.mainForm.get('password')?.value,
            organization: this.mainForm.get('organization')?.value,
            department: this.mainForm.get('department')?.value,
            roles: [this.currentRole||{} as Role],
            status: this.data['status'],
            rights: this.data['rights'],
        }
        this.dialogRef.close(res);
    }

    ngOnInit() {
        this.mainForm.valueChanges.subscribe((v) => {
            console.log('mainForm', v);
        })
        this.mainForm.get('phone')!.valueChanges.subscribe((v) => {
            this.mainForm.get('phone')!.setValue(_phoneMask(v), {emitEvent: false});
        })
        this.mainForm.get('organization')!.valueChanges.subscribe((v) => {
            console.log('organization', v);
        })
    }

    onOrganizationSelected($event: MatAutocompleteSelectedEvent) {
        console.log($event);
    }
}

export const _phoneMask = (phone: string): string => {
    return phone.replace(/\D/g, '')
        .replace(/^(\d)/, '($1')
        .replace(/^(\(\d{3})(\d)/, '$1) $2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})(\d{1,2})$/, '$1-$2')
        .replace(/(-\d{2})(\d{2})(\d+)$/, '$1-$2');
}
